import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBudgetStep3 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 488,
	height: 420,
	viewBox: "0 0 488 420",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M323.509 268.873H295.469V365.862H323.509V268.873Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M303.723 268.873H275.683V365.862H303.723V268.873Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M298.382 365.861H303.723V350.688H292.798L298.382 365.861Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M162.792 268.873H134.752V365.862H162.792V268.873Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M303.723 268.873H158.18V358.457H303.723V268.873Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M294.619 338.307H237.567C234.533 338.307 231.983 335.879 231.983 332.723V278.22C231.983 275.185 234.411 272.636 237.567 272.636H294.498C297.533 272.636 300.082 275.064 300.082 278.22V332.723C300.203 335.758 297.654 338.307 294.619 338.307ZM237.689 273.971C235.261 273.971 233.319 275.914 233.319 278.22V332.723C233.319 335.151 235.261 337.093 237.567 337.093H294.498C296.926 337.093 298.868 335.151 298.868 332.844C298.868 332.844 298.868 332.844 298.868 332.723V278.22C298.868 275.792 296.926 273.971 294.498 273.971H237.689Z",
					fill: "#E0E0E0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M224.215 338.307H167.284C164.249 338.307 161.7 335.879 161.7 332.723V278.22C161.7 275.185 164.128 272.636 167.284 272.636H224.215C227.249 272.636 229.798 275.064 229.798 278.22V332.723C229.798 335.758 227.249 338.307 224.215 338.307ZM167.163 273.971C164.735 273.971 162.914 275.914 162.914 278.22V332.723C162.914 335.151 164.856 336.971 167.163 336.971H224.093C226.521 336.971 228.463 335.029 228.463 332.723V278.22C228.463 275.792 226.521 273.971 224.093 273.971H167.163Z",
					fill: "#E0E0E0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M218.873 289.873C215.96 289.873 213.532 287.445 213.532 284.532C213.532 281.619 215.96 279.191 218.873 279.191C221.787 279.191 224.214 281.619 224.214 284.532C224.214 287.567 221.908 289.873 218.873 289.873Z",
					fill: "#FAFAFA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M242.907 289.873C239.994 289.873 237.566 287.567 237.566 284.532C237.566 281.619 239.873 279.191 242.907 279.191C245.821 279.191 248.249 281.497 248.249 284.532C248.249 284.532 248.249 284.532 248.249 284.653C248.249 287.567 245.821 289.873 242.907 289.873Z",
					fill: "#FAFAFA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M163.521 365.861H158.18V350.688H169.105L163.521 365.861Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M153.931 268.873H125.891V365.862H153.931V268.873Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M148.59 365.861H153.931V350.688H143.006L148.59 365.861Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M153.931 268.873H8.3877V358.457H153.931V268.873Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M144.827 338.307H87.7752C84.7405 338.307 82.1914 335.879 82.1914 332.723V278.22C82.1914 275.185 84.7405 272.636 87.7752 272.636H144.706C147.741 272.636 150.29 275.064 150.29 278.22V332.723C150.29 335.758 147.862 338.307 144.827 338.307ZM87.7752 273.971C85.3475 273.971 83.4053 275.914 83.4053 278.22V332.723C83.4053 335.151 85.3475 337.093 87.6538 337.093H144.584C147.012 337.093 148.954 335.151 148.954 332.844C148.954 332.844 148.954 332.844 148.954 332.723V278.22C148.954 275.792 147.012 273.971 144.706 273.971H87.7752Z",
					fill: "#E0E0E0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M74.422 338.307H17.3699C14.3353 338.307 11.7861 335.879 11.7861 332.723V278.22C11.7861 275.185 14.2139 272.636 17.3699 272.636H74.3006C77.3353 272.636 79.8844 275.064 79.8844 278.22V332.723C79.8844 335.758 77.4567 338.307 74.422 338.307ZM17.3699 273.971C14.9422 273.971 13 275.914 13 278.22V332.723C13 335.151 14.9422 337.093 17.2486 337.093H74.1792C76.6069 337.093 78.5491 335.151 78.5491 332.844V278.22C78.5491 275.792 76.6069 273.971 74.1792 273.971H17.3699Z",
					fill: "#E0E0E0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M69.0813 289.873C66.168 289.873 63.7402 287.445 63.7402 284.532C63.7402 281.619 66.168 279.191 69.0813 279.191C71.9946 279.191 74.4223 281.619 74.4223 284.532C74.4223 287.567 71.9946 289.873 69.0813 289.873Z",
					fill: "#FAFAFA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M93.1164 289.873C90.2031 289.873 87.7754 287.567 87.7754 284.532C87.7754 281.619 90.0817 279.191 93.1164 279.191C96.0297 279.191 98.4575 281.497 98.4575 284.532C98.4575 284.532 98.4575 284.532 98.4575 284.653C98.4575 287.567 96.0297 289.873 93.1164 289.873Z",
					fill: "#FAFAFA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.6073 365.861H8.3877V350.688H19.1912L13.6073 365.861Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M265.608 0H213.411V52.1965H265.608V0Z",
					fill: "#EBEBEB"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M267.793 0H265.486V52.1965H267.793V0Z",
					fill: "#E0E0E0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M258.445 7.04053H220.451V45.0347H258.445V7.04053Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M245.821 32.4103C242.301 35.9305 236.596 35.9305 233.076 32.4103C229.555 28.89 229.555 23.1848 233.076 19.6646C236.596 16.1444 242.301 16.1444 245.821 19.6646C249.342 23.1848 249.342 28.89 245.821 32.4103Z",
					fill: "#F5F5F5"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M214.503 67.0059H153.324V128.185H214.503V67.0059Z",
					fill: "#EBEBEB"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M217.174 67.0059H214.504V128.185H217.174V67.0059Z",
					fill: "#E0E0E0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M206.127 75.3813H161.578V119.93H206.127V75.3813Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M193.382 88.1274H174.324V107.185H193.382V88.1274Z",
					fill: "#F5F5F5"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M487.989 47.3408H454.851V55.1096H487.989V47.3408Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M454.85 47.3408H317.804V55.1096H454.85V47.3408Z",
					fill: "#F5F5F5"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M395.735 6.31201H357.134V47.3409H395.735V6.31201Z",
					fill: "#E0E0E0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M357.012 6.31201H347.18V47.3409H357.012V6.31201Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M405.809 0H376.798V47.341H405.809V0Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M376.798 0H368.422V47.341H376.798V0Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M409.694 6.31201H385.295V47.3409H409.694V6.31201Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M385.295 6.31201H379.711V47.3409H385.295V6.31201Z",
					fill: "#FAFAFA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M437.37 13.231H405.324V47.3408H437.37V13.231Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M405.446 13.231H397.191V47.3408H405.446V13.231Z",
					fill: "#FAFAFA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M445.746 8.01172H421.711V47.3412H445.746V8.01172Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M421.711 8.01172H414.792V47.3412H421.711V8.01172Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M452.18 13.231H428.752V47.3408H452.18V13.231Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M428.751 13.231H424.139V47.3408H428.751V13.231Z",
					fill: "#FAFAFA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M435.185 276.642C445.503 263.046 470.266 258.069 478.763 249.451C489.931 238.283 489.931 221.41 480.341 215.341C472.087 210.121 444.654 245.688 441.619 249.694C431.058 263.41 427.902 273.607 425.96 283.439C426.203 275.064 426.446 267.416 426.567 261.468C427.174 242.168 427.902 235.855 428.145 234.035C429.359 233.064 430.694 231.971 431.422 231.485C438.099 226.509 452.787 220.682 460.07 213.52C470.752 203.081 469.052 190.457 461.526 185.844C453.636 180.988 439.798 192.52 432.394 203.931C424.989 215.341 428.145 226.387 426.081 235.734C425.596 237.555 425.232 244.717 424.746 254.549C423.047 244.838 417.706 236.22 409.815 230.272C399.619 222.139 390.879 212.306 382.503 213.52C374.128 214.734 378.74 227.844 385.295 237.069C391.243 245.202 420.376 253.457 424.625 260.011C424.139 273.364 423.654 290.116 423.411 305.896C421.104 297.763 422.683 297.156 413.336 284.653C407.752 277.248 384.81 268.144 382.139 273.243C379.469 278.341 383.596 287.931 392.214 294.607C399.255 300.069 414.671 300.069 418.313 303.347C419.162 304.075 421.954 307.11 423.532 308.809C423.168 327.988 423.047 344.861 423.168 350.688H424.625C424.503 349.231 424.746 339.399 424.989 326.532C428.752 319.613 454.122 315.607 461.891 308.566C470.024 301.04 475.972 292.422 472.451 286.595C469.538 281.74 446.474 288.295 437.006 296.428C430.815 301.769 426.931 307.474 425.232 315.243C425.474 306.503 425.717 297.035 425.96 288.052C427.781 285.867 432.151 280.647 435.185 276.642Z",
					fill: "#E6E6E6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M437.492 365.618H411.151C409.694 365.618 408.481 363.798 408.238 361.127L406.417 344.133H442.348L440.527 361.127C440.163 363.798 438.949 365.618 437.492 365.618Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M443.076 350.688H405.567C404.718 350.688 403.868 349.474 403.868 347.775L403.14 335.15C403.018 333.208 403.868 331.509 404.839 331.509H443.804C444.897 331.509 445.625 333.208 445.504 335.15L444.775 347.775C444.654 349.474 443.926 350.688 443.076 350.688Z",
					fill: "#F0F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M244.607 420C374.598 420 479.977 413.859 479.977 406.283C479.977 398.708 374.598 392.566 244.607 392.566C114.616 392.566 9.2373 398.708 9.2373 406.283C9.2373 413.859 114.616 420 244.607 420Z",
					fill: "#F5F5F5"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M332.492 208.908L207.584 216.191C203.215 216.434 198.845 217.526 194.717 219.347L59.0064 280.041C54.0296 282.226 51.359 287.567 52.4515 292.786L74.9082 398.757C76.4862 406.041 84.4978 409.804 91.2954 406.526L225.186 339.642L348.879 335.515C355.434 335.272 360.168 329.445 359.197 323.133L342.689 221.653C341.839 216.312 337.833 208.786 332.492 208.908Z",
					fill: "#2771bb"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .1,
					d: "M332.492 208.908L207.584 216.191C203.215 216.434 198.845 217.526 194.717 219.347L59.0064 280.041C54.0296 282.226 51.359 287.567 52.4515 292.786L74.9082 398.757C76.4862 406.041 84.4978 409.804 91.2954 406.526L225.186 339.642L348.879 335.515C355.434 335.272 360.168 329.445 359.197 323.133L342.689 221.653C341.839 216.312 337.833 208.786 332.492 208.908Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M81.7229 139.895L16.209 200.277L133.847 327.914L199.361 267.532L81.7229 139.895Z",
					fill: "#2771bb"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .5,
					d: "M199.33 267.537L133.781 327.988L16.1562 200.289L59.2487 160.716L81.7054 139.838L85.4684 143.965L199.33 267.537Z",
					fill: "#FAFAFA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M82.1485 147.662L24.3105 200.969L134.38 320.393L192.218 267.086L82.1485 147.662Z",
					stroke: "#2771bb",
					strokeMiterlimit: 10
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M121.319 248.122C127.974 241.987 127.143 230.261 119.464 221.93C111.784 213.599 100.164 211.819 93.5095 217.953C86.8547 224.088 87.6853 235.814 95.3647 244.145C103.044 252.476 114.664 254.256 121.319 248.122Z",
					fill: "#2771bb"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .1,
					d: "M133.174 276.156L109.868 284.167L59.249 160.716L81.7057 139.838L85.4687 143.965L133.174 276.156Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M137.585 89.9288L53.8242 120.293L112.982 283.48L196.743 253.115L137.585 89.9288Z",
					fill: "#2771bb"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .5,
					d: "M137.585 89.9288L53.8242 120.293L112.982 283.48L196.743 253.115L137.585 89.9288Z",
					fill: "#FAFAFA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M134.967 97.3283L61.0195 124.135L116.371 276.823L190.318 250.016L134.967 97.3283Z",
					stroke: "#2771bb",
					strokeMiterlimit: 10
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M132.249 205.008C140.757 201.924 144.524 190.789 140.663 180.138C136.802 169.486 126.774 163.352 118.266 166.437C109.758 169.521 105.99 180.656 109.852 191.307C113.713 201.958 123.74 208.092 132.249 205.008Z",
					fill: "#2771bb"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M333.341 213.278L210.133 220.197C205.763 220.439 201.515 221.532 197.509 223.353L63.7399 283.682C58.8845 285.867 56.2139 291.208 57.3064 296.307L79.7631 402.278C81.3411 409.561 89.3527 413.445 95.9076 410.046L227.856 343.526L349.85 339.642C356.283 339.399 361.017 333.694 360.046 327.26L343.416 225.781C342.567 220.682 338.561 213.035 333.341 213.278Z",
					fill: "#2771bb"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M215.11 238.769L320.839 232.214",
					stroke: "black",
					strokeWidth: 2,
					strokeMiterlimit: 10,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M202.485 241.439L221.786 330.174",
					stroke: "black",
					strokeWidth: 2,
					strokeMiterlimit: 10,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M73.6943 321.555L87.2897 389.775C87.2897 389.775 97.729 362.705 73.6943 321.555Z",
					fill: "#FAFAFA"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M75.5146 322.405C76.0002 323.619 196.538 271.908 196.538 271.908C196.538 271.908 199.572 309.052 163.278 329.445C126.983 349.717 75.5146 322.405 75.5146 322.405Z",
					fill: "#FAFAFA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M155.51 324.347C158.392 324.347 160.729 322.01 160.729 319.127C160.729 316.245 158.392 313.908 155.51 313.908C152.627 313.908 150.29 316.245 150.29 319.127C150.29 322.01 152.627 324.347 155.51 324.347Z",
					fill: "#2771bb"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M196.538 271.908C196.538 271.908 211.469 294.364 207.827 332.723L196.538 271.908Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("g", {
					opacity: .2,
					children: /* @__PURE__ */ _jsxs("g", {
						opacity: .2,
						children: [
							/* @__PURE__ */ _jsx("path", {
								opacity: .2,
								d: "M67.8672 294.728L70.6591 293.514",
								stroke: "#FAFAFA",
								strokeLinecap: "round",
								strokeLinejoin: "round"
							}),
							/* @__PURE__ */ _jsx("path", {
								opacity: .2,
								d: "M76.4854 290.965L189.011 241.196",
								stroke: "#FAFAFA",
								strokeLinecap: "round",
								strokeLinejoin: "round",
								strokeDasharray: "5.2 5.2"
							}),
							/* @__PURE__ */ _jsx("path", {
								opacity: .2,
								d: "M191.925 239.982L194.595 238.769",
								stroke: "#FAFAFA",
								strokeLinecap: "round",
								strokeLinejoin: "round"
							})
						]
					})
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M218.63 258.677L324.358 252.122",
					stroke: "black",
					strokeWidth: 2,
					strokeMiterlimit: 10,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M223.364 283.561L329.093 277.006",
					stroke: "black",
					strokeWidth: 2,
					strokeMiterlimit: 10,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M305.907 106.821C305.907 106.821 303.237 135.104 292.676 137.532C282.115 139.96 273.254 135.59 273.254 135.59L264.757 129.035L260.63 143.601C260.63 143.601 265.243 149.792 274.711 145.543C274.711 145.543 291.705 153.069 301.052 145.543C310.399 138.017 313.433 117.503 313.433 117.503L305.907 106.821Z",
					fill: "#FFB573"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M314.404 93.1041C314.404 93.1041 307.121 80.6012 310.398 57.9018C313.676 35.2023 332.734 32.4104 340.138 33.9885C347.422 35.6879 353.491 42.7284 358.468 56.081C363.445 69.5549 365.266 72.9538 373.641 70.6474C382.017 68.3411 404.231 60.9364 410.3 67.4914C416.491 74.0463 414.427 81.3295 414.427 81.3295C414.427 81.3295 445.26 73.8035 442.589 101.358C439.919 128.913 395.37 154.526 353.005 127.335C310.763 100.266 314.404 93.1041 314.404 93.1041Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M314.04 159.746C314.04 159.746 305.665 231.85 305.908 265.717C306.15 299.584 318.168 379.214 318.168 379.214H332.977C332.977 379.214 331.035 315.486 331.277 293.636C331.52 271.786 335.526 235.734 335.526 235.734C335.526 235.734 340.26 268.145 345.844 279.677C351.428 291.087 382.503 331.63 403.988 344.255L414.064 335.029C414.064 335.029 391.728 307.353 383.353 293.636C374.977 279.919 367.451 276.035 364.295 250.544C361.26 225.052 366.48 184.266 357.619 159.625H314.04V159.746Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M335.647 235.856L329.214 190.093C329.214 190.093 324.115 217.526 334.191 251.151L335.647 235.856Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M321.323 383.341L321.809 397.544L331.763 398.393L332.248 397.058V382.37L321.323 383.341Z",
					fill: "#FFB573"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M316.589 378L317.439 383.219L334.554 383.705L335.647 377.271L316.589 378Z",
					fill: "#2771bb"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M399.375 345.347L415.277 330.538L418.676 336.121L405.202 348.503L399.375 345.347Z",
					fill: "#2771bb"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M407.022 345.347L417.462 354.087L424.259 346.197L415.641 337.335L407.022 345.347Z",
					fill: "#FFB573"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M426.202 345.59L432.514 349.474C433.728 350.202 433.97 351.902 432.999 352.994C428.387 358.214 416.733 371.324 415.52 372.173C414.063 373.387 412.363 371.324 411.878 369.503C411.878 369.503 415.155 365.133 415.52 362.341C415.762 360.277 415.641 357.243 415.52 355.786C415.52 355.179 415.641 354.694 416.005 354.329L423.046 346.075C424.017 345.225 425.231 344.983 426.202 345.59Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M334.19 398.757L335.526 406.04C335.768 407.497 334.676 408.711 333.219 408.711C326.3 408.711 308.699 408.832 307.242 408.59C305.422 408.225 305.786 405.676 306.757 404.098C306.757 404.098 312.219 403.613 314.526 402.035C316.225 400.821 318.41 398.757 319.381 397.665C319.745 397.301 320.231 397.058 320.838 397.058L331.763 396.815C332.976 396.815 333.948 397.543 334.19 398.757Z",
					fill: "#263238"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M359.318 119.809L374.492 109.127C374.492 109.127 370.486 92.9828 364.538 92.2545C358.59 91.4048 328.971 85.821 310.035 92.2545C310.035 92.2545 303.237 94.1967 301.174 113.254L309.185 115.804C309.185 115.804 312.099 151.37 313.919 156.954H356.891C356.891 156.833 357.376 126.243 359.318 119.809Z",
					fill: "#2771bb"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M362.595 117.503C362.595 117.503 368.3 133.89 369.393 142.752C369.393 142.752 355.797 137.289 352.277 134.861L349.607 125.272L340.503 120.902L337.832 128.064L345.358 137.41C345.358 137.41 365.872 156.59 376.312 152.22C386.751 147.85 372.185 110.827 372.185 110.827L362.595 117.503Z",
					fill: "#FFB573"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M323.994 45.763C323.994 45.763 318.774 56.2023 319.138 64.8208C319.502 73.4393 323.872 76.8381 332.005 78.052C332.005 78.052 335.526 88.9768 326.3 90.0693C325.572 90.1907 325.329 92.9826 325.45 93.3468C325.693 95.1676 327.393 96.1387 329.092 96.5028C330.792 96.9884 332.612 96.9884 334.312 97.1098C338.196 97.2312 341.474 95.6531 344.144 92.7398C344.387 92.4971 346.208 90.1907 346.208 90.1907C346.208 90.1907 341.838 88.0057 343.416 73.8034C343.416 73.8034 346.329 72.104 348.029 68.0982C348.029 68.0982 350.82 66.6416 351.549 63.8497C352.156 61.0577 349.728 57.052 345.115 61.0577C345.115 61.0577 336.497 56.6878 333.219 41.393C333.098 41.2716 329.699 45.0346 323.994 45.763Z",
					fill: "#FFB573"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M326.422 62.3929L327.15 56.8091L323.145 61.179C323.266 61.179 324.48 62.6357 326.422 62.3929Z",
					fill: "#A24E3F"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M328.729 66.5201C328.729 66.5201 332.977 67.1271 334.919 64.4565",
					stroke: "#222221",
					strokeWidth: .75,
					strokeMiterlimit: 10,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M332.977 48.9194C332.977 48.9194 335.647 47.9483 338.439 50.376",
					stroke: "#222221",
					strokeMiterlimit: 10,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M325.693 47.705C325.693 47.705 323.265 47.3409 322.173 48.6761",
					stroke: "#222221",
					strokeMiterlimit: 10,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M334.585 56.3713C334.698 55.507 334.357 54.7503 333.826 54.6812C333.294 54.6121 332.772 55.2568 332.659 56.1211C332.547 56.9854 332.887 57.742 333.419 57.8111C333.951 57.8802 334.473 57.2356 334.585 56.3713Z",
					fill: "#222221"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M324.962 54.4401C325.075 53.5758 324.734 52.8192 324.203 52.7501C323.671 52.681 323.149 53.3257 323.036 54.19C322.924 55.0543 323.264 55.8109 323.796 55.88C324.328 55.949 324.85 55.3044 324.962 54.4401Z",
					fill: "#222221"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M333.827 54.6241L331.885 53.7744C331.885 53.8958 332.37 55.5952 333.827 54.6241Z",
					fill: "#222221"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M324.358 52.9249L322.416 52.0752C322.416 52.0752 322.78 53.7746 324.358 52.9249Z",
					fill: "#222221"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M312.341 154.89V159.989L358.954 160.353L357.74 154.405L312.341 154.89Z",
					fill: "#2771bb"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .4,
					d: "M312.341 154.89V159.989L358.954 160.353L357.74 154.405L312.341 154.89Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M201.393 177.832C198.723 184.387 182.942 183.902 166.312 177.104C149.804 170.306 138.515 159.503 141.185 152.948C141.792 151.491 143.491 145.786 145.434 145.058C151.624 142.509 163.278 148.335 176.023 153.555C187.798 158.41 201.393 161.566 203.457 168C204.913 171.884 202.122 176.011 201.393 177.832Z",
					fill: "#fad504"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M203.578 168C204.549 173.098 202.364 175.526 201.393 177.832C200.422 180.26 197.63 181.717 193.745 182.202C193.26 182.324 192.774 182.324 192.289 182.324C189.618 182.566 186.583 182.324 183.306 181.838C182.82 181.838 182.456 181.717 181.971 181.595C178.693 180.988 175.294 180.139 171.653 178.925C171.289 178.803 170.925 178.682 170.439 178.561C169.104 178.075 167.647 177.59 166.312 176.983C164.977 176.376 163.641 175.769 162.306 175.162C161.942 175.04 161.578 174.798 161.214 174.676C157.936 173.098 155.023 171.277 152.352 169.457C151.988 169.214 151.745 168.971 151.381 168.728C148.711 166.786 146.404 164.723 144.705 162.78C144.462 162.416 144.098 162.173 143.855 161.809C141.185 158.532 140.214 155.376 141.306 152.827C142.034 151.249 143.491 145.665 145.555 144.936C147.618 144.208 150.289 144.208 153.445 144.936C153.809 145.058 154.294 145.058 154.659 145.179C160.728 146.757 168.375 150.156 176.144 153.433C185.37 157.196 196.294 161.202 201.514 165.694C201.878 165.936 202.121 166.301 202.485 166.543C202.849 167.15 203.214 167.514 203.578 168Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("g", {
					opacity: .2,
					children: /* @__PURE__ */ _jsx("path", {
						opacity: .2,
						d: "M155.145 144.33L154.538 145.301L144.705 162.902C144.462 162.538 144.098 162.295 143.855 161.931L153.324 145.058L154.052 143.723L155.145 144.33Z",
						fill: "black"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					opacity: .2,
					children: /* @__PURE__ */ _jsx("path", {
						opacity: .2,
						d: "M162.549 151.491L152.353 169.699C151.989 169.457 151.746 169.214 151.382 168.971L161.457 150.884L162.549 151.491Z",
						fill: "black"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					opacity: .2,
					children: /* @__PURE__ */ _jsx("path", {
						opacity: .2,
						d: "M181.243 161.93L171.653 179.167C171.289 179.046 170.925 178.925 170.439 178.803L180.15 161.445L181.243 161.93Z",
						fill: "black"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					opacity: .2,
					children: /* @__PURE__ */ _jsx("path", {
						opacity: .2,
						d: "M172.624 157.075L162.427 175.404C162.063 175.283 161.699 175.04 161.335 174.919L171.653 156.589L172.624 157.075Z",
						fill: "black"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					opacity: .2,
					children: /* @__PURE__ */ _jsx("path", {
						opacity: .2,
						d: "M192.653 165.208L183.306 181.959C182.82 181.959 182.456 181.838 181.971 181.717L191.56 164.601L192.653 165.208Z",
						fill: "black"
					})
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M203.467 172.085C206.151 165.578 194.913 154.77 178.367 147.945C161.82 141.12 146.231 140.862 143.546 147.369C140.862 153.876 152.1 164.684 168.647 171.509C185.193 178.335 200.783 178.593 203.467 172.085Z",
					fill: "#fad504"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M197.9 169.809C199.792 165.223 190.725 157.133 177.649 151.739C164.573 146.345 152.439 145.691 150.547 150.277C148.656 154.862 157.722 162.953 170.798 168.346C183.875 173.74 196.008 174.395 197.9 169.809Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M285.029 118.96C289.399 124.543 281.144 138.017 266.942 148.942C252.74 159.867 237.809 164.237 233.439 158.653C232.468 157.318 228.462 153.069 228.705 151.006C229.555 144.329 240.479 137.046 251.283 128.671C261.358 120.78 270.826 110.705 277.503 112.04C281.63 113.012 283.815 117.382 285.029 118.96Z",
					fill: "#fad504"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M277.624 112.162C282.601 113.862 283.572 117.018 285.15 118.96C286.728 121.023 286.607 124.179 285.15 127.821C285.029 128.307 284.786 128.671 284.543 129.156C283.451 131.584 281.752 134.133 279.688 136.682C279.445 137.047 279.202 137.411 278.838 137.653C276.775 140.203 274.226 142.752 271.434 145.301C271.07 145.544 270.827 145.786 270.463 146.151C269.37 147.122 268.278 147.971 267.064 148.942C265.85 149.792 264.757 150.763 263.543 151.492C263.179 151.734 262.815 151.977 262.572 152.22C259.538 154.284 256.503 155.983 253.711 157.318C253.347 157.561 252.983 157.682 252.619 157.804C249.584 159.139 246.671 160.11 244.122 160.596C243.636 160.717 243.272 160.717 242.786 160.838C238.659 161.445 235.382 160.838 233.682 158.653C232.59 157.318 228.584 153.191 228.948 151.006C229.312 148.821 230.769 146.515 232.833 144.208C233.075 143.966 233.439 143.601 233.682 143.237C238.052 138.746 244.85 133.89 251.526 128.671C259.416 122.601 268.278 115.075 274.832 112.769C275.197 112.648 275.682 112.526 276.046 112.405C276.532 112.283 277.017 112.283 277.624 112.162Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("g", {
					opacity: .2,
					children: /* @__PURE__ */ _jsx("path", {
						opacity: .2,
						d: "M232.954 142.387L233.56 143.358L244 160.717C243.514 160.838 243.15 160.838 242.665 160.959L232.711 144.329L231.982 142.994L232.954 142.387Z",
						fill: "black"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					opacity: .2,
					children: /* @__PURE__ */ _jsx("path", {
						opacity: .2,
						d: "M242.908 139.474L253.59 157.318C253.226 157.561 252.862 157.682 252.498 157.804L241.815 140.081L242.908 139.474Z",
						fill: "black"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					opacity: .2,
					children: /* @__PURE__ */ _jsx("path", {
						opacity: .2,
						d: "M261.237 128.428L271.433 145.301C271.069 145.543 270.826 145.786 270.462 146.15L260.266 129.035L261.237 128.428Z",
						fill: "black"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					opacity: .2,
					children: /* @__PURE__ */ _jsx("path", {
						opacity: .2,
						d: "M252.74 133.647L263.543 151.613C263.179 151.856 262.815 152.098 262.572 152.341L251.769 134.254L252.74 133.647Z",
						fill: "black"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					opacity: .2,
					children: /* @__PURE__ */ _jsx("path", {
						opacity: .2,
						d: "M269.734 120.295L279.566 136.682C279.324 137.046 279.081 137.411 278.717 137.653L268.642 120.78L269.734 120.295Z",
						fill: "black"
					})
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M263.317 144.202C277.469 133.242 285.447 119.845 281.136 114.28C276.826 108.715 261.86 113.088 247.709 124.048C233.557 135.008 225.579 148.405 229.889 153.97C234.199 159.535 249.165 155.162 263.317 144.202Z",
					fill: "#fad504"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M261.54 140.882C272.723 132.22 279.327 122.019 276.289 118.097C273.251 114.175 261.723 118.017 250.539 126.678C239.356 135.339 232.753 145.54 235.79 149.463C238.828 153.385 250.356 149.543 261.54 140.882Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M226.52 92.8613C225.064 100.873 207.22 104.272 186.948 100.63C166.676 96.9885 151.382 87.6416 152.717 79.6301C153.081 77.8093 153.567 71.0116 155.509 69.6763C161.821 65.185 176.387 68.948 192.046 71.7399C206.613 74.289 222.515 74.5318 226.52 81.2081C228.827 85.3353 226.885 90.5549 226.52 92.8613Z",
					fill: "#fad504"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M226.52 81.2081C228.948 86.6705 227.006 90.0693 226.52 92.8612C226.034 95.7745 223.243 98.0809 218.994 99.6589C218.508 99.9017 217.901 100.023 217.416 100.266C214.503 101.116 210.982 101.723 207.219 101.965C206.734 101.965 206.248 101.965 205.763 102.087C202 102.208 197.873 102.087 193.503 101.601C193.017 101.601 192.532 101.48 192.046 101.48C190.347 101.237 188.769 100.994 187.069 100.751C185.37 100.509 183.792 100.144 182.092 99.7803C181.607 99.6589 181.121 99.5376 180.757 99.4162C176.751 98.4451 172.988 97.1098 169.589 95.7745C169.104 95.6532 168.74 95.4104 168.254 95.289C164.734 93.711 161.699 92.0115 159.271 90.1907C158.907 89.8266 158.422 89.5838 158.058 89.2196C154.295 86.1849 152.352 82.9075 152.959 79.7514C153.323 77.8092 153.566 71.1329 155.751 69.7977C157.936 68.4624 160.971 67.8555 164.612 67.8555C165.098 67.8555 165.584 67.8555 166.069 67.8555C173.352 68.0982 182.699 70.1618 192.289 71.8612C203.578 73.9248 216.809 75.6243 223.971 79.3873C224.456 79.63 224.821 79.8728 225.185 80.1156C225.549 80.3584 226.034 80.7225 226.52 81.2081Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("g", {
					opacity: .2,
					children: /* @__PURE__ */ _jsx("path", {
						opacity: .2,
						d: "M166.191 66.3986L165.827 67.7339L159.029 89.9478C158.665 89.5836 158.18 89.3408 157.815 88.9767L164.249 67.6125L164.735 65.9131L166.191 66.3986Z",
						fill: "black"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					opacity: .2,
					children: /* @__PURE__ */ _jsx("path", {
						opacity: .2,
						d: "M176.266 72.7113L169.347 95.6535C168.861 95.5322 168.497 95.2894 168.012 95.168L174.931 72.3472L176.266 72.7113Z",
						fill: "black"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					opacity: .2,
					children: /* @__PURE__ */ _jsx("path", {
						opacity: .2,
						d: "M199.936 79.873L193.381 101.601C192.896 101.601 192.41 101.48 191.925 101.48L198.601 79.5088L199.936 79.873Z",
						fill: "black"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					opacity: .2,
					children: /* @__PURE__ */ _jsx("path", {
						opacity: .2,
						d: "M188.89 76.4738L181.85 99.5374C181.364 99.416 180.879 99.2946 180.515 99.1733L187.555 75.9883L188.89 76.4738Z",
						fill: "black"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					opacity: .2,
					children: /* @__PURE__ */ _jsx("path", {
						opacity: .2,
						d: "M213.41 80.8441L207.098 101.966C206.613 101.966 206.127 101.966 205.642 102.087L212.197 80.48L213.41 80.8441Z",
						fill: "black"
					})
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M227.502 85.8747C228.924 77.8885 213.596 68.4818 193.268 64.8642C172.94 61.2466 155.308 64.788 153.887 72.7742C152.466 80.7603 167.793 90.167 188.121 93.7846C208.45 97.4022 226.081 93.8608 227.502 85.8747Z",
					fill: "#fad504"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M220.48 84.6643C221.49 78.9882 209.307 72.073 193.269 69.2189C177.231 66.3647 163.41 68.6524 162.4 74.3285C161.39 80.0046 173.573 86.9197 189.611 89.7739C205.649 92.628 219.47 90.3404 220.48 84.6643Z",
					fill: "white"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 487.977,
				height: 420,
				fill: "white",
				transform: "translate(0.0117188)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgBudgetStep3);
export default ForwardRef;
